import * as React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

export default function BasicDatePicker({
  label,
  onChange,
  value,
  margin,
  smallWidth,
}) {
  const handleDateChange = (date) => {
    // Format the date using dayjs
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    // Call the parent onChange with the formatted date
    onChange(formattedDate);
  };

  // Function to disable dates before today
  const disablePastDates = (date) => {
    return dayjs(date).isBefore(dayjs(), "day");
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]} sx={margin ? { flex: 1 } : {}}>
        <DatePicker
          label={label}
          slotProps={{ textField: { size: "small" } }}
          sx={!smallWidth ? { width: "100%" } : {}}
          onChange={handleDateChange}
          value={value && dayjs(value)}
          defaultValue={""}
          format="DD.MM.YYYY"
          shouldDisableDate={disablePastDates} // Disable past dates
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
